'use strict'

/**
 * Canonical label for a route/crew-shaped item across the Routing UI.
 *
 * Policy (decided 2026-06-16): ALWAYS prefer the Aspire route name over legacy
 * crew info. The server already emits a route-preferring `displayName` (see
 * `buildRouteName`/`preferRouteCrewName` in
 * server/src/hmi/routeOptimizer/territoryProperties.controller.js); this helper
 * consumes that first, then degrades gracefully so older payloads that only
 * carry `crewName`/`foremanName` still render something sensible.
 *
 * Fallback order:
 *   displayName → routeName/RouteName/assignedRouteName → name
 *     → crewName/assignedCrewName → foremanName → id
 *
 * Note on `name`: the `/territory/properties` endpoint maps each ROUTE object's
 * label to `name` (= buildRouteName, the Aspire route name) and only CREW objects
 * carry a legacy crew `name`. So `name` sits ABOVE crewName/foremanName here: for
 * a route object it yields the route name (what we want); for a bare crew object
 * it's the legacy name, which is the only label available anyway.
 *
 * Keep this the single source of truth for the fallback order so every spot in
 * the routing UI agrees. See memory note route-crew-link-sync for context.
 *
 * @param {Object} item  a route, crew-summary, stop, or marker-props object
 * @returns {string} the best available human label (never null/undefined)
 */
export function routeDisplayName (item) {
  if (!item) return ''
  return (
    item.displayName ||
    item.routeName ||
    item.RouteName ||
    item.assignedRouteName ||
    item.name ||
    item.crewName ||
    item.assignedCrewName ||
    item.foremanName ||
    String(item.routeId || item.crewId || item._id || '')
  )
}

export default routeDisplayName
